module.exports = __webpack_public_path__ + "img/nb-logo.18b89f5d.png";